<div class="mb-2">
  <input
    id="nameField_{{ itemId() }}"
    type="text"
    [(ngModel)]="name"
    (ngModelChange)="updateName($event)"
    [class.is-invalid]="itemError()?.name"
    class="form-control form-control-sm"
    placeholder="Description"
    [ngbTooltip]="nameError"
    [disableTooltip]="!itemError()?.name"
    placement="bottom" />
  <ng-template #nameError>
    <div class="text-danger">
      @for (error of itemError()?.name; track $index) {
        <div>{{ error }}</div>
      }
    </div>
  </ng-template>
</div>

<!-- Temp disable unit price and qty fields until design ready -->
<div class="row align-items-center g-2 mb-2 d-none">
  <div class="col">
    <input
      id="unitPriceField_{{ itemId() }}"
      type="text"
      [(ngModel)]="unitPrice"
      (focus)="onUnitPriceFocus()"
      (blur)="updateUnitPrice(unitPrice)"
      [class.is-invalid]="itemError()?.unit_price"
      class="form-control form-control-sm"
      placeholder="Unit price"
      currencyMask
      [currencyMask]="maskConfig"
      [ngbTooltip]="unitPriceError"
      [disableTooltip]="!itemError()?.unit_price"
      placement="bottom" />
    <ng-template #unitPriceError>
      <div class="text-danger">
        @for (error of itemError()?.unit_price; track $index) {
          <div>{{ error }}</div>
        }
      </div>
    </ng-template>
  </div>
  <div class="col">
    <input
      id="unitQuantityField_{{ itemId() }}"
      type="number"
      [(ngModel)]="unitQuantity"
      (blur)="updateUnitQuantity(unitQuantity)"
      [class.is-invalid]="itemError()?.unit_quantity"
      class="form-control form-control-sm"
      placeholder="Qty"
      [ngbTooltip]="unitQuantityError"
      [disableTooltip]="!itemError()?.unit_quantity"
      placement="bottom" />
    <ng-template #unitQuantityError>
      <div class="text-danger">
        @for (error of itemError()?.unit_quantity; track $index) {
          <div>{{ error }}</div>
        }
      </div>
    </ng-template>
  </div>
</div>

<div class="row align-items-center g-2 flex-nowrap mb-2">
  @if (trackingCategories().length > 0) {
    <div class="{{ trackingCategories().length > 1 ? 'col-12' : 'col' }}">
      <app-tracking-categories
        [component]="'splitTransaction'"
        [selectedTrackingCats]="selectedTracking"
        (selectedTrackingCatsChange)="updateTracking($event)"></app-tracking-categories>
    </div>
  }
</div>

<div class="row align-items-center g-2 mb-2">
  <div class="col">
    <input
      id="amountField_{{ itemId() }}"
      type="text"
      [(ngModel)]="amount"
      (blur)="updateAmount(amount)"
      [class.is-invalid]="itemError()?.amount"
      class="form-control form-control-sm"
      placeholder="R0.00"
      currencyMask
      [currencyMask]="maskConfig"
      [ngbTooltip]="amountError"
      [disableTooltip]="!itemError()?.amount"
      placement="bottom" />
    <ng-template #amountError>
      <div class="text-danger">
        @for (error of itemError()?.amount; track $index) {
          <div>{{ error }}</div>
        }
      </div>
    </ng-template>
  </div>
  <div class="col">
    @if (hasActiveConnection() && provider() === AccountingProviderCompany.XERO) {
      <app-tax-rate-select
        [preferredTaxRateId]="preferredTaxRateId()"
        [component]="'splitTransaction'"
        [selectedTaxRate]="selectedTaxRateObject()"
        (selectedTaxRateChange)="updateTaxRate($event)"></app-tax-rate-select>
    } @else {
      <ng-select
        id="vatTypeField_{{ itemId() }}"
        [(ngModel)]="vatType"
        (ngModelChange)="updateVatType($event)"
        [items]="vatOptions"
        bindLabel="option"
        bindValue="value"
        [clearable]="false"
        [searchable]="false"
        placeholder="Select VAT"
        class="ng-select-sm">
      </ng-select>
    }
  </div>
</div>
